/**
 * Created with Mei Zhiwei on 2017-11-30 17:05:02.
 * Description: 基础信息
 *
 * @author meizhiwei@meituan.com
 * @version 1.0.0
 * @Last Modified by: fanzhijie
 * @Last Modified time: 2021-04-30 14:33:56
 */
import { host } from '@/config';
import * as types from '@/store/mutation-types.js';
import axios from '@/lib/axios.js';
import _ from 'lodash';

const state = {
  user: {
    uid: '',
    loaded: false,
    vendorId: 0
  },
  statuses: [],
  bizTypes: [],
  accessTypes: [],
  appTypes: [],
  opBizList: {
    loaded: false,
    bizList: [],
    bizOnlyList: []
  }
}
// getters
const getters = {
  loginUser: state => state.user,
  opBizList: state => state.opBizList
}

// actions
const actions = {
  loadUser({ commit }) {
    if (!state.user.loaded) {
      axios.get(host.CURRENT_USER).then(({ data }) => {
        commit(types.CURRENT_USER, data.user)
      })
    }
  },
  loadOpBizList({commit}) {
    let icons = ['ios-analytics', 'ios-paper', 'ios-barcode', 'ios-color-filter', 'ios-easel', 'ios-navigate', 'ios-school', 'ios-ribbon', 'ios-podium', 'ios-outlet'];
    // let s = {
    //   loaded: false,
    //   bizList: [
    //     {
    //       title: '美团码',
    //       name: 'couponDocOverView1'
    //     },
    //     {
    //       title: '美团码1',
    //       name: 'couponDocOverView2'
    //     },
    //     {
    //       title: '美团码2',
    //       name: 'couponDocOverView3'
    //     }
    //   ]
    // }
    axios.get(host.DOC_ALL_BIZ).then(({data}) => {
      let s = {
        loaded: false,
        bizList: data,
        bizOnlyList: []
      }
      s.bizList.forEach((element, index) => {
        element.icon = icons[index % 10];
        element.uniqueId = 'BizUni_' + element.id + '_' + element.bizType;
        if (element.name && element.name.indexOf('帮助') < 0 && element.name.indexOf('指南') < 0) {
          s.bizOnlyList.push(element);
        }
      });
      commit(types.OP_BIZ_LIST, s);
    })
  }
};

// mutations
const mutations = {
  [types.CURRENT_USER](state, user) {
    state.user.loaded = true;
    if (user) {
      _.assign(state.user, user);
      state.user.loaded = true;
    }
  },
  [types.OP_BIZ_LIST](state, opBizList) {
    state.opBizList.loaded = true;
    if (opBizList) {
      _.assign(state.opBizList, opBizList);
      state.opBizList.loaded = true;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/base.js